import { memo } from 'react'

import type { IUploadButtonProps } from './upload-button.types'
import { UploadButtonView } from './upload-button.view'

const Component = ({ children, ...props }: IUploadButtonProps) => {
  return <UploadButtonView {...props}>{children}</UploadButtonView>
}

export const UploadButton = memo(Component)
